<template>
  <v-card flat>
    <div class="table__overflow">
      <table class="datatable table">
        <thead>
          <tr>
            <th class="expert">{{ $t('availabilities.expertsperday.header.expert') }}</th>
            <th
              v-for="hour in hours" :key="hour"
              class="cell">
              <minute :value="hour * 60 * 60" display-empty></minute>
            </th>
            <th class="result"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="expert in experts" :key="expert.id">
            <td class="expert">
              {{ expert.nickname }}
            </td>
            <availability-cell
              v-for="hour in hours" :key="hour"
              :availabilities="availabilitiesOf(expert, hour)"
              :maxHours="1"
              class="cell">
            </availability-cell>
            <td class="result">
              <minute :value="totalExpertsHour[expert.id] * 60 * 60" display-empty></minute>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td class="expert"></td>
            <td
              v-for="hour in hours" :key="hour"
              class="cell">
              <minute :value="totalHourForHour(hour) / 1000" display-empty></minute>
            </td>
            <td class="result pr-3">
              <minute :value="totalHours / 1000" display-empty></minute>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </v-card>
</template>

<script>
  import { Timezone } from 'skiliko-sdk'
  import { Minute } from '@/components/formatters'
  import AvailabilityCell from './AvailabilityCell.vue'
  export default {
    components: {
      Minute,
      AvailabilityCell
    },
    props: {
      day: {
        type: Number,
        required: true
      },
      experts: {
        type: Array,
        required: true
      },
      smartHours: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      startsAt () {
        return this.smartHours ? this.getMaxValue(
          e => e.from.getHours(),
          (a, b) => a - b
        ) : 0
      },
      endsAt () {
        return this.smartHours ? this.getMaxValue(
          e => e.to.getHours() || 24,
          (a, b) => b - a
        ) : 24
      },
      hours () {
        const shift = this.startsAt
        const hours = (this.endsAt || 24) - shift
        return [...new Array(hours)].map((_, i) => i + shift)
      },
      totalExpertsHour () {
        return this.experts.reduce((acc, expert) => ({
          ...acc,
          [expert.id]: this.expertSchedule(expert)
            .reduce((sum, value) => sum + (+value.to - +value.from), 0) / (1000 * 60 * 60)
        }), {})
      },
      totalHours () {
        return this.hours
          .reduce((sum, hour) => this.totalHourForHour(hour) + sum, 0)
      }
    },
    methods: {
      adjustDate (comparator, date, hour) {
        let newDate = date.getDay() > this.day
          ? new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1, hour)
          : new Date(date.getFullYear(), date.getMonth(), date.getDate(), hour)
        return new Date(comparator(+date, +newDate))
      },
      availabilitiesOf (expert, hour) {
        return this.expertSchedule(expert)
          .filter(x => x.from.getHours() <= hour)
          .filter(x => (x.to.getHours() || 24) >= hour)
          .map(x => ({
            from: this.adjustDate(Math.max, x.from, hour),
            to: this.adjustDate(Math.min, x.to, hour + 1)
          }))
      },
      totalHourForHour (hour) {
        return this.experts
          .map(x => this.availabilitiesOf(x, hour)
            .reduce((sum, availability) => sum + Math.max((availability.to - availability.from), 0), 0)
          )
          .reduce((sum, x) => sum + x, 0)
      },
      expertSchedule (expert) {
        return Timezone
          .scheduleToCurrentDates(expert.schedule, expert.timezone, expert.timezone_offset)[this.day]
      },
      getMaxValue (item, sort) {
        return this.experts
          .map(expert => this.expertSchedule(expert))
          .map(schedule => schedule
            .map(item)
            .sort(sort)[0]
          )
          .sort(sort)[0]
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "../../variables"

  $cell-width := 50px;
  $expert-width := 150px;
  $result-width := 110px;

  thead {
    border-bottom: 1px solid $material-twelve-percent-dark;
  }

  .cell {
    text-align: center!important;
    width: $cell-width;
    min-width: $cell-width;
    max-width: $cell-width;
    padding: 0!important;
  }

  .expert {
    text-align: left;
    width: $expert-width;
    min-width: $expert-width;
    max-width: $expert-width;
  }

  .result {
    text-align: right;
    width: $result-width;
    min-width: $result-width;
    max-width: $result-width;
  }
</style>



// WEBPACK FOOTER //
// src/components/availabilities/ExpertsPerDay.vue